import { WalletItemResponse } from "types/Api/Wallet/walletItemResponse";

export const getWalletItems = (state: any): WalletItemResponse[] => state.wallet.walletItems;
